
<template>
  <section class="container-fluid">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <div class="row">
                <div class="col-12 col-xl-5"><CIcon name="cil-grid" />Horarios</div>
                <div class="col-12 col-xl-7">
                  <div class="row">
                    <div class="col-12 col-xl-3">
                      <div class="form-group">
                        <label class="control-label" for="courses_offered_year"
                          >Gestión:</label
                        >
                        <b-form-select
                          v-model="columnFilter.courses_offered_year"
                          :options="coursesOfferedYearsOptions"
                          id="courses_offered_year"
                          size="sm"
                          @change="filterTable"
                        >
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-12 col-xl-4">
                      <div class="form-group">
                        <label class="control-label" for="period"
                          >Periodo:</label
                        >

                        <b-form-select
                          v-model="columnFilter.period"
                          :options="periodOptions"
                          value-field="value"
                          text-field="name"
                          id="period"
                          size="sm"
                          @change="filterTable"
                        >
                        </b-form-select>
                      </div>
                    </div>
                    <!-- Pénsum -->
                    <div class="col-12 col-xl-4">
                      <div class="form-group required">
                        <label class="control-label" for="syllabus_id"
                          >Pénsum</label
                        >
                        <b-form-select
                          v-model="columnFilter.syllabus_id"
                          :options="syllabusOptions"
                          value-field="id"
                          text-field="description"
                          id="syllabus_id"
                          size="sm"
                          @change="filterTable"
                        >
                          <b-form-select-option :value="null"
                            >--Seleccione un pénsum--</b-form-select-option
                          >
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-12 col-xl-1 float-right">
                      <CDropdown
                        color="secondary"
                        toggler-text="Dropdown Button"
                        class="mt-3"
                        size="sm"
                      >
                        <template #toggler-content>
                          <span><CIcon size="sm" name="cil-print" /></span>
                        </template>
                        <CDropdownItem @click="print()"
                          >Imprimir PDF</CDropdownItem
                        >
                        <CDropdownItem @click="excel()"
                          >Descargar excel</CDropdownItem
                        >
                      </CDropdown>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              class="table-bordered c-table c-table-main"
              :bordered="true"
              :small="true"
              :items="items"
              :fields="fields"
              :sorter="{ external: true, resetable: true }"
              @update:sorter-value="filterTable"
              :columnFilter="{ external: true, lazy: true }"
              @update:column-filter-value="filterTable"
              :column-filter-value.sync="columnFilter"
              :loading="loading"
            >
              <template #no-items-view>
                <div class="no-items-view">
                  {{
                    loading
                      ? "Cargando datos..."
                      : "No existen horarios asignados"
                  }}
                  <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                </div>
              </template>
              <!-- filters -->
              <template #detail-filter>
                <b-button
                  @click="reload"
                  variant="secondary"
                  size="sm"
                  title="Recargar tabla"
                >
                  <CIcon size="sm" name="cil-reload" />
                </b-button>
                <b-button
                  @click="clean"
                  variant="secondary"
                  size="sm"
                  title="Limpiar filtros"
                >
                  <CIcon size="sm" name="cil-filter-x" />
                </b-button>
              </template>
              <!-- data -->
              <template #id="{ index }">
                <td>{{ (page - 1) * limit + (index + 1) }}</td>
              </template>

              <template #period="{ item }">
                <td class="text-center">
                  {{ item.period }}/{{ item.courses_offered_year }}
                </td>
              </template>
              <template #course_name="{ item }">
                <td>
                  {{ item.course_name }} {{ item.parallel | parallel_list }}
                </td>
              </template>
              <template #schedule="{ item }">
                <td>
                  {{ item | time_courses_offered }}
                </td>
              </template>
              <template #detail>
                <td></td>
              </template>
            </CDataTable>
          </CCardBody>
          <div>
            <CPagination
              :activePage.sync="page"
              :pages="pages"
              size="sm"
              align="center"
              @update:activePage="updateTable"
            />
            <TableRecords
              :total="total"
              :loading="loading"
              :from="from"
              :to="to"
              :page="page"
            />
          </div>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import {
  BAlert,
  BModal,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
  BFormInvalidFeedback,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import CoursesOffered from "@/plugins/services/courses-offered";
import Syllabus from "@/plugins/services/syllabus";

export default {
  name: "ScheduleList",
  components: {
    BAlert,
    BModal,
    BButton,
    BButtonGroup,
    BFormSelect,
    BFormSelectOption,
    BFormInvalidFeedback,
    TableRecords,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width: 8px;",
        },
        {
          key: "person_fullname",
          label: "Profesor",
          _style: "min-width: 150px;",
          sorter: false,
        },
        {
          key: "course_name",
          label: "Curso",
          _style: "width: 15%;",
          sorter: false,
        },
        {
          key: "period",
          label: "Periodo",
          _style: "width: 5%;",
          filter: false,
          sorter: false,
        },
        {
          key: "classroom",
          label: "Aula",
          sorter: false,
          _style: "width: 10%;",
          sorter: false,
        },
        {
          key: "syllabus_description",
          label: "Pensum",
          sorter: false,
          _style: "min-width: 150px;",
          sorter: false,
        },
        {
          key: "schedule",
          filter: false,
          label: "Horario",
          _style: "min-width: 150px;",
          sorter: false,
        },
        {
          key: "detail",
          label: "",
          sorter: false,
          _style: "width: 90px;",
        },
      ],
      items: [],
      teacher: null,
      columnFilter: {
        column: null,
        asc: false,
        enabled: true,
        period: 1,
        syllabus_id: null,
      },
      coursesOfferedYearsOptions: [],
      periodOptions: Constants.periodOptions2,
      typeOfCourseOptions: Constants.typeOfCourseOptions,
      enabledOptions: Constants.enabledOptions,
      syllabusOptions: [],
      page: 0,
      pages: 0,
      limit: 20,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
      dataEmit: { modalShow: false, data: null },
    };
  },
  mounted() {
    this.columnFilter.courses_offered_year = Utils.getYear(this.userAuth.now);
    this.getAll(this.columnFilter);
    this.getCoursesOfferedYears();
    this.getSyllabus();
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      Utils.columnFilter("courses-offered", q);
      CoursesOffered.indexSchedule(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = {
        column: null,
        asc: false,
        enabled: true,
        courses_offered_year: Utils.getYear(this.userAuth.now),
        period: 1,
        syllabus_id: null,
      };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter);
    },
    getCoursesOfferedYears() {
      this.coursesOfferedYearsOptions = Utils.getYears(this.userAuth.now);
    },
    // search Syllabus
    getSyllabus() {
      Syllabus.selectAll({ enabled: true })
        .then((res) => {
          this.syllabusOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    print() {
      let cFilter = this.columnFilter;
      let querystring = Utils.encodeQueryData(cFilter);
      let teacherSchedule = `${process.env.MIX_APP_API_ENDPOINT}/courses-offered/schedule-pdf?${querystring}`;
      Utils.printPdf(teacherSchedule);
    },
    excel() {
      let cFilter = this.columnFilter;
      let querystring = Utils.encodeQueryData(cFilter);
      let teacherSchedule = `${process.env.MIX_APP_API_ENDPOINT}/courses-offered/schedule-excel?${querystring}`;
      window.open(teacherSchedule, "_blank");
    },
  },
};
</script>
